// @flow
import {ofType} from 'redux-observable';
import {map, switchMap} from 'rxjs/operators';
import {
  // getSubscriptionInformationApi,
  getSubscriptionPriceApi,
  getStripeSubscriptionInformationApi,
} from './api';
import {LoginSuccess, GetSessionSuccess} from '../auth/duck';
import {ActionCreator, buildCatchError, createReducer} from '../../store/utils';

import type {ActionsObservable, StateObservable} from 'redux-observable';
import type {Action} from '../../store/utils';
import type {Subscription} from '../../entities/subscription';
import type {TierDetail} from './api';
import {RENEWAL_PRO_TIERS, type StoreTierPricing} from '../../entities';
import type {RootState} from '../index';
import {
  FreeTrialSubscribeSuccess,
  PerformSubscribeSuccess,
} from '../checkout/duck';
import {SaveSubscriptionSettingSuccess} from '../profile/account/duck';
import {FetchStoreSuccess} from '../store/duck';
import {mapStripeToSubscription} from './utils/subscription-adapter';
// import off38 from '../../assets/img/38off.svg';
// import off22 from '../../assets/img/22off.svg';

export type TiersListAction = Action & {
  error?: string,
  plan?: TierDetail,
  currency?: string,
};

export type TiersListState = {
  fetchedTiersPricing?: boolean,
  error?: string,
  savingSuccess?: boolean,
  basicPlans: TierDetail[],
  proPlusPlans: TierDetail[],
  trialPlans: TierDetail[],
  planSelectedCurrency?: string,
  planSelected?: TierDetail,
  currentSubscription?: Subscription,
  nextSubscription?: Subscription,
  dueInformation?: Subscription,
};

export class FetchTiersList extends ActionCreator<TiersListAction> {}
export class FetchTiersListSuccess extends ActionCreator<TiersListAction> {}
export class FetchTiersListErrorFn extends ActionCreator<TiersListAction> {}

export class SetPlanSelectedCurrency extends ActionCreator<TiersListAction> {}

export class SetPlanSelected extends ActionCreator<TiersListAction> {}
export class ResetPlanSelected extends ActionCreator<TiersListAction> {}

export class FetchTierInformation extends ActionCreator<TiersListAction> {}

export class FetchSubscriptionInformation extends ActionCreator<TiersListAction> {}
export class FetchSubscriptionInformationSuccess extends ActionCreator<TiersListAction> {}
export class FetchSubscriptionInformationErrorFn extends ActionCreator<TiersListAction> {}

export class FetchDueInformationSuccess extends ActionCreator<TiersListAction> {}
export class FetchDueInformationErrorFn extends ActionCreator<TiersListAction> {}

export class FetchSubscriptionPriceSuccess extends ActionCreator<TiersListAction> {}
export class FetchSubscriptionPriceErrorFn extends ActionCreator<TiersListAction> {}

export class TiersListResetState extends ActionCreator<TiersListAction> {}

export const actions = {
  fetchTiersList: () => new FetchTiersList(),
  resetState: () => new TiersListResetState(),
  setPlanSelectedCurrency: (payload: TiersListAction) =>
    new SetPlanSelectedCurrency(payload),
  setPlanSelected: (payload: TiersListAction) => new SetPlanSelected(payload),
  resetPlanSelected: () => new ResetPlanSelected(),
  fetchTierInformation: () => new FetchTierInformation(),
  fetchSubscriptionInformation: () => new FetchSubscriptionInformation(),
};

export const initialState = {
  basicPlans: [
    {
      prices: [],
      name: 'ANNUAL',
      label: 'Plan Básico Anual',
      // discount: off38,
    },
    {
      prices: [],
      name: 'QUARTERLY',
      label: 'Plan Básico Trimestral',
      // discount: off22,
    },

    {
      prices: [],
      name: 'MONTHLY',
      label: 'Plan Básico Mensual',
    },
  ],
  proPlusPlans: [
    {
      prices: [],
      name: 'ANNUAL',
      label: 'Plan PRO+ Anual',
    },

    {
      prices: [],
      name: 'QUARTERLY',
      label: 'Plan PRO+ Trimestral',
    },
    {
      prices: [],
      name: 'MONTHLY',
      label: 'Plan PRO+ Mensual',
    },
  ],
};

export default createReducer<TiersListState>(initialState, {
  [FetchTiersList.type]: _ => ({isFetching: true}),
  [FetchTiersListSuccess.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    error: undefined,
    isFetching: true,
  }),
  [FetchTiersListErrorFn.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    error: action.error,
    isFetching: false,
  }),
  [SetPlanSelectedCurrency.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    planSelectedCurrency: action.currency,
  }),
  [SetPlanSelected.type]: (state: TiersListState, action: TiersListAction) => ({
    ...state,
    planSelected: action.plan,
  }),
  [ResetPlanSelected.type]: state => ({
    ...state,
    planSelected: undefined,
  }),
  [PerformSubscribeSuccess.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    nextSubscription: action.data,
  }),
  [FetchSubscriptionInformationSuccess.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    currentSubscription: action.data,
  }),
  [FetchSubscriptionInformationErrorFn.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    currentSubscription: null,
  }),
  [FetchDueInformationSuccess.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    dueInformation: action.data,
  }),
  [FetchDueInformationErrorFn.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    dueInformation: null,
  }),
  [FetchSubscriptionPriceSuccess.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    basicPlans: action.basicPlans,
    proPlusPlans: action.proPlusPlans,
    trialPlans: action.trialPlans,
    fetchedTiersPricing: true,
  }),
  [FetchSubscriptionPriceErrorFn.type]: (
    state: TiersListState,
    action: TiersListAction
  ) => ({
    ...state,
    error: action.error,
  }),

  [TiersListResetState.type]: _ => initialState,
});

export function fetchSubscriptionInformationEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(
      GetSessionSuccess.type,
      LoginSuccess.type,
      PerformSubscribeSuccess.type,
      FreeTrialSubscribeSuccess.type,
      FetchSubscriptionInformation.type,
      SaveSubscriptionSettingSuccess.type
    ),
    switchMap(() =>
      /*       getSubscriptionInformationApi().pipe(
        map(
          dataSubscription =>
            new FetchSubscriptionInformationSuccess({data: dataSubscription})
        ),
        buildCatchError(FetchSubscriptionInformationErrorFn)
      ) */
      getStripeSubscriptionInformationApi().pipe(
        map(dataSubscription => {
          const subscription = mapStripeToSubscription(dataSubscription);
          return new FetchSubscriptionInformationSuccess({
            data: subscription,
          });
        }),
        buildCatchError(FetchSubscriptionInformationErrorFn)
      )
    )
  );
}
/* export function getDueInformationEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(
      GetSessionSuccess.type,
      LoginSuccess.type,
      PerformSubscribeSuccess.type,
      FreeTrialSubscribeSuccess.type
    ),
    switchMap(() =>
      getDueInformationApi().pipe(
        map(
          dataSubscription =>
            new FetchDueInformationSuccess({data: dataSubscription})
        ),
        buildCatchError(FetchDueInformationErrorFn)
      )
    )
  );
} */
export function fetchSubscriptionPriceEpic(
  action$: ActionsObservable,
  state$: StateObservable<RootState>
) {
  return action$.pipe(
    ofType(FetchStoreSuccess.type),
    switchMap(() =>
      getSubscriptionPriceApi().pipe(
        map((pricesSubscription: StoreTierPricing[]) => {
          const isSelectedBasicTier = ['TIER_210', 'TIER_310'].includes(
            state$.value?.store?.store?.storeTier.name
          );
          let BASIC_TIER_PRICING = ['TIER_310'];
          if (!isSelectedBasicTier) BASIC_TIER_PRICING = ['TIER_309'];

          const basicPlans = state$.value.tiersList.basicPlans.map(
            (tierPricing: TierDetail) => {
              const data = pricesSubscription.find(
                item =>
                  item.frequency.name === tierPricing.name &&
                  BASIC_TIER_PRICING.includes(item.storeTier.name)
              );
              return {
                ...data,
                label: tierPricing.label,
              };
            }
          );
          const proPlusPlans = state$.value.tiersList.proPlusPlans.map(
            (tierPricing: TierDetail) => {
              const data = pricesSubscription.find(
                item =>
                  item.frequency.name === tierPricing.name &&
                  RENEWAL_PRO_TIERS.includes(item.storeTier.name)
              );
              return {
                ...data,
                label: tierPricing.label,
              };
            }
          );

          const trialPlans = pricesSubscription.filter(
            item => item.storeTier.name >= 'TIER_4'
          );

          return new FetchSubscriptionPriceSuccess({
            basicPlans,
            proPlusPlans,
            trialPlans,
          });
        }),
        buildCatchError(
          FetchSubscriptionPriceErrorFn,
          'Error al obtener los precios de planes'
        )
      )
    )
  );
}
